import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
  GET_SAVED_PROPERTIES,
  GetSavedPropertiesFailure,
  GetSavedPropertiesSuccess,
  UPDATE_SAVED_PROPERTIES,
  UpdateSavedProperties,
  UpdateSavedPropertiesSuccess,
  UpdateSavedPropertiesFailure
} from '@store/saved-properties/saved-properties.actions';
import { SavedPropertiesService } from '@root/saved-properties/services/saved-properties.service';
import { PropertyUtil } from '@shared/utils/property-util';
import { PropertyInformation } from '@store/search-board/search-board.model';

@Injectable()
export class SavedPropertiesEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly savedPropertiesService: SavedPropertiesService) {
  }

  getSavedProperties$: Observable<GetSavedPropertiesSuccess | GetSavedPropertiesFailure> = createEffect(() =>
    this.actions$.pipe(
      ofType(GET_SAVED_PROPERTIES),
      switchMap(() => {
        return this.savedPropertiesService.getSavedProperties().pipe(
          catchError(() => of(void (0))),
          map((properties: Array<PropertyInformation>) =>
            properties ? new GetSavedPropertiesSuccess(properties) : new GetSavedPropertiesFailure())
        );
      })
    ));

  updateSavedProperties$: Observable<UpdateSavedPropertiesSuccess | UpdateSavedPropertiesFailure> = createEffect(() =>
    this.actions$.pipe(
      ofType(UPDATE_SAVED_PROPERTIES),
      switchMap((action: UpdateSavedProperties) => {
        const updatedSavedProperties: Array<PropertyInformation> = action.payload;
        return this.savedPropertiesService.updateSavedProperties(PropertyUtil.getPropertyIdentifiers(updatedSavedProperties)).pipe(
          map(() => new UpdateSavedPropertiesSuccess(updatedSavedProperties)),
          catchError(() => of(new UpdateSavedPropertiesFailure()))
        );
      })
    ));
}
